/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rmf_Degraded_TitleInputs */

const en_rmf_degraded_title = /** @type {(inputs: Rmf_Degraded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RMF startup incomplete`)
};

const fr_rmf_degraded_title = /** @type {(inputs: Rmf_Degraded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement RMF incomplet`)
};

const ms_sg2_rmf_degraded_title = /** @type {(inputs: Rmf_Degraded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permulaan RMF tidak lengkap`)
};

/**
* | output |
* | --- |
* | "RMF startup incomplete" |
*
* @param {Rmf_Degraded_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const rmf_degraded_title = /** @type {((inputs?: Rmf_Degraded_TitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rmf_Degraded_TitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rmf_degraded_title(inputs)
	if (locale === "fr") return fr_rmf_degraded_title(inputs)
	return ms_sg2_rmf_degraded_title(inputs)
});